module.exports = __webpack_public_path__ + "static/narau-8ab960f51c71dfaedd505951255283f4.jpg";